import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { DoctorIntro } from './components/DoctorIntro';
import { BarbaraStory } from './components/BarbaraStory';
import { Science } from './components/Science';
import { ProductReveal } from './components/ProductReveal';
import { Timeline } from './components/Timeline';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { DoctorClose } from './components/DoctorClose';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-offwhite font-inter text-ink selection:bg-gold/30" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <DoctorIntro data-id="element-4" />
        <BarbaraStory data-id="element-5" />
        <Science data-id="element-6" />
        <ProductReveal data-id="element-7" />
        <Timeline data-id="element-8" />
        <Pricing data-id="element-9" />
        <Guarantee data-id="element-10" />
        <Testimonials data-id="element-11" />
        <DoctorClose data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
    </div>;
}